import {
  DisplayTypes,
  ESdChangeReason,
  ICreateElementFromActionMessage,
  IRenderFrameMessage,
  IStylingPosition,
  SpecialDIIds
} from "@kuika/kuika-cl-model";
import { PartialContextProvider } from "../../../shared/patial/partial-context-provider";
import { DESIGN_CHANGED_EVENT } from "../../../shared/utility/issues/issues-model";
import { KMainFunctions } from "../../../shared/utility/main-functions";
import { ScreenDesignHelper } from "../../../shared/utility/screen-design-helper";
import { IScreenDesignContextState } from "../screen-design-context";
import { IScreenDesignContextProviderProps, ScreenDesignContextProvider } from "../screen-design-context-provider";

export interface FrameProviderState {
  isDesignFrameLoading: boolean;
  injectDiToTargetDi: (message: ICreateElementFromActionMessage) => void;
  replaceDi: (message: ICreateElementFromActionMessage) => void;
}

export class FrameProvider extends PartialContextProvider<
  ScreenDesignContextProvider,
  IScreenDesignContextProviderProps,
  IScreenDesignContextState,
  FrameProviderState
> {
  static defaultState: FrameProviderState = {
    isDesignFrameLoading: true,
    injectDiToTargetDi: () => {},
    replaceDi: () => {}
  };

  getProviderValues = (): FrameProviderState => {
    return {
      isDesignFrameLoading: this.state.isDesignFrameLoading,
      injectDiToTargetDi: this.partial.frame.injectDiToTargetDi,
      replaceDi: this.partial.frame.replaceDi
    };
  };

  renderFrame = (changeReason: ESdChangeReason) => {
    let sd = this.partial.screenProvider.getScreenDesign();
    // root DI force block.
    const rootDI = sd.displayItems.find((x) => x.id === SpecialDIIds.rootDI);
    if (rootDI === undefined || KMainFunctions.isObjectEmpty(rootDI) === true) {
      sd = ScreenDesignHelper.createRootDI(sd, this.partial.screenProvider.getScreenDesignDictionary());
    }
    let msd = this.partial.screenProvider.state?.masterSd;
    const sdPublic = this.partial.screenProvider.getScreenPublic(sd.id);
    if (rootDI) {
      if (rootDI.styleObj === undefined) {
        rootDI.styleObj = {};
      }
      if (rootDI.styleObj.position === undefined) {
        rootDI.styleObj.position = {} as IStylingPosition;
      }
      rootDI.styleObj.position.display = DisplayTypes.Block;
    }
    const activeKuikaComponent = this.partial.displayItemProvider.getActiveKuikaComponent();
    if (sd !== undefined && this.state.project !== undefined && this.state.dashboardState !== undefined) {
      const message: IRenderFrameMessage = {
        projectTempStyles: this.state.projectTempStyles,
        activeKuikaComponent,
        dashboardState: this.state.dashboardState,
        project: this.state.project,
        screenDesign: sd,
        masterScreenDesign: msd,
        changeReason,
        sdPublic,
        designTimeLockedElementIds: Array.from(this.state.lockedElementIds),
        designTimeHiddenElementIds: Array.from(this.state.hiddenElementIds)
      };
      this.partial.frame.renderFrame(message);
      // The canvas re-rendered from a change (edit / style / hide-lock / load) — let
      // validation-dependent chrome (the header Issues "all-clear ✓") invalidate, since its
      // last validation is now stale until the next preview.
      window.dispatchEvent(new Event(DESIGN_CHANGED_EVENT));
    }
  };

  frameMessage = (event: any) => {
    if (event && event.data && event.data.iframeMessage) {
      this.partial.frameMessageReceiver.receive(event.data.iframeMessage);
    }
  };
}
